import React, { Component,Fragment } from 'react';
import { connect } from 'react-redux';
import { Button, Card, CardBody, Col, Container, Row } from 'reactstrap';
import { invalidateRegister,toggleData ,find} from '../../store/actions/userActions';
import { Link } from 'react-router-dom';

class Confirmation extends Component {
	constructor(props){
		super(props);
		if (this.props.match.params.id && this.props.match.params.token) {
			this.props.find(this.props.match.params.id ,this.props.match.params.token);
		}
	}

	onChange = (target) => {
		
    	let { name, value } = target,
			data = {
				'name': name, 
				'data': value
			};
	    this.props.toggleData(data);
    }

	render(){
		return<div className="app flex-row align-items-center" >
			<Container>
				<Row className="justify-content-center">
					<Col md="6">
						<Card className="p-2">
							<CardBody>
								<h1>{this.props.json_lang.invalidate_email.error_explanation_title}</h1>
									
								<p className="text-muted justify-content-center">
									{
									this.props.account && this.props.account.length ?
										this.props.json_lang.invalidate_email.error_description_msg
									:
										'Token invalido/Usuario ya confirmado'
									}
								</p>
								<Row>
									<Col xs="12">
										{
											this.props.account && this.props.account.length ?
											<Fragment>
												<Button color="warning" className="px-4 pull-right" onClick={ () => this.props.invalidateRegister(this.props.account) }> 
													{this.props.json_lang.invalidate_email.invalidate_button} 
												</Button>
												<Link className="px-4 pull-right btn btn-light mr-2" to="/" > {this.props.json_lang.confirmation.back_button} </Link>
											</Fragment>
											:null
										}
									</Col>
								</Row>
							</CardBody>
						</Card>									
					</Col>
				</Row>
			</Container>
		</div>
	}
}



const mapStateToProps = (state) => {

	return {
		errors: state.errors,
		account:state.account,
		json_lang: state.json_lang
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		find:(id,token) => dispatch(find(id,token)),
		invalidateRegister: (user) => dispatch(invalidateRegister(user)),
		toggleData: (data) => dispatch(toggleData(data))
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(Confirmation);


// WEBPACK FOOTER //
// ./src/views/Register/InvalidateEmail.jsx